module.exports = __webpack_public_path__ + "img/up-arrow.c2e07919.svg";